import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  ButtonBase,
} from "@material-ui/core";
import AddIcon from "@mui/icons-material/Add";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import RemoveIcon from "@mui/icons-material/Remove";
import CustomAvatar from "components/CustomAvatar";
import CustomModal, { Title } from "components/CustomModal";
import CustomTextbox from "components/CustomTextbox";
import {
  CREATE_PROJECT_GROUP,
  CustomEventDispose,
  CustomEventListener,
  DETAIL_PROJECT_GROUP,
  EDIT_PROJECT_GROUP,
  LIST_PROJECT_GROUP,
} from "constants/events.js";
import { useMaxlenString, useRequiredString } from "hooks";
import { get } from "lodash";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { LogoManagerContext } from "views/DepartmentPage/Modals/LogoManager/presenters";
import { colors } from "../ColorGroupPickerModal";
import "./style.scss";
import { useLocation } from "react-router";
import ColorGroupPickerPopover from "../ColorGroupPickerPopover";
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import { Box } from "@mui/material";
import {
  CustomEventEmitter,
  EDIT_COLOR_PROJECT_GROUP_REDUCER,
} from "../../../../constants/events";
import ModalCommon from "components/ModalCommon";
import ButtonModalCommon from "components/ModalCommon/ButtonModalCommon";

const ThemeLogoBox = ({ className = "", ...props }) => (
  <div
    className={`view_ProjectGroup_Create_ProjectGroup___logo-box ${className}`}
    {...props}
  />
);

const LogoBox = ({ className = "", isSelect, ...props }) => (
  <div
    className={`${
      isSelect
        ? "view_Department_Logo_Modal___logo-box-selected createProjectGroup__logo-box"
        : "view_Department_Logo_Modal___logo-box createProjectGroup__logo-box"
    } ${className}`}
    {...props}
  />
);

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function CreateProjectGroup({
  updatedProjectGroup,
  open,
  setOpen,
  handleCreateOrEditProjectGroup,
  handleOpenModal,
  doReloadDetail,
  doReloadList,
  selectedColor,
  setSelectedColor,
  handleSelectColor,
  createSuccessCallBack = () => {},
}) {
  const query = useQuery();
  const groupID = query.get("groupID");
  const { t } = useTranslation();
  const [name, setName, errorName] = useRequiredString("", 150);
  const [description, setDescription] = useMaxlenString("", 500);

  const [activeLoading, setActiveLoading] = React.useState(false);
  const [isAddingDescription, setIsAddingDescription] = React.useState(false);
  // const [selectedColor, setSelectedColor] = React.useState(colors[0]);
  const { icons, isSelect, selectedIcon, setSelectedIcon, defaultIcon } =
    useContext(LogoManagerContext);
  React.useEffect(() => {
    if (!updatedProjectGroup) {
      return;
    }
    setName(get(updatedProjectGroup, "name"));
    setDescription(get(updatedProjectGroup, "description"));
    setSelectedColor(get(updatedProjectGroup, "color"));

    const foundedIconDefault = icons.defaults.find(
      (icon) => icon.url_icon === updatedProjectGroup.icon
    );
    const foundedIconCreateds = icons.createds.find(
      (icon) => icon.url_full === updatedProjectGroup.icon
    );
    if (foundedIconDefault) {
      setSelectedIcon({
        url_full: foundedIconDefault.url_icon,
        url_sort: foundedIconDefault.icon,
      });
    } else if (foundedIconCreateds) {
      setSelectedIcon({
        url_full: foundedIconCreateds.url_full,
        url_sort: foundedIconCreateds.url_sort,
      });
    }
  }, [updatedProjectGroup]);

  // console.log(updatedProjectGroup, "updatedProjectGroup updatedProjectGroup");

  React.useEffect(() => {
    const fail = () => {
      setActiveLoading(false);
    };
    if (updatedProjectGroup) {
      CustomEventListener(EDIT_PROJECT_GROUP.SUCCESS, doReloadDetail);
      CustomEventListener(EDIT_PROJECT_GROUP.FAIL, fail);
    } else {
      CustomEventListener(CREATE_PROJECT_GROUP.SUCCESS, doReloadList);
      CustomEventListener(CREATE_PROJECT_GROUP.SUCCESS, createSuccessCallBack);
      CustomEventListener(CREATE_PROJECT_GROUP.FAIL, fail);
    }
    return () => {
      if (updatedProjectGroup) {
        CustomEventDispose(EDIT_PROJECT_GROUP.SUCCESS, doReloadDetail);
        CustomEventDispose(EDIT_PROJECT_GROUP.FAIL, fail);
      } else {
        CustomEventDispose(CREATE_PROJECT_GROUP.SUCCESS, doReloadList);
        CustomEventDispose(CREATE_PROJECT_GROUP.SUCCESS, createSuccessCallBack);
        CustomEventDispose(CREATE_PROJECT_GROUP.FAIL, fail);
      }
    };
    // eslint-disable-next-line
  }, [updatedProjectGroup]);

  React.useEffect(() => {
    const fail = () => {
      setActiveLoading(false);
    };
    if (updatedProjectGroup) {
      CustomEventListener(DETAIL_PROJECT_GROUP.SUCCESS, doReloadList);
      CustomEventListener(DETAIL_PROJECT_GROUP.FAIL, fail);
    }
    return () => {
      if (updatedProjectGroup) {
        CustomEventDispose(DETAIL_PROJECT_GROUP.SUCCESS, doReloadList);
        CustomEventDispose(DETAIL_PROJECT_GROUP.FAIL, fail);
      }
    };
    // eslint-disable-next-line
  }, [updatedProjectGroup]);

  const onComplete = () => {
    setActiveLoading(false);
    setOpen(false);
    setName("");
    setDescription("");
    if (icons.defaults.length > 0) {
      setSelectedIcon({
        id: get(icons.defaults[0], "id", ""),
        url_sort: get(icons.defaults[0], "icon"),
        url_full: get(icons.defaults[0], "url_icon"),
      });
    }
    CustomEventEmitter("ADD_LEFT_PROJECT_GROUP" + groupID);
    CustomEventEmitter(EDIT_COLOR_PROJECT_GROUP_REDUCER);
  };

  React.useEffect(() => {
    const success = () => {};
    const fail = () => {
      setActiveLoading(false);
    };
    CustomEventListener(LIST_PROJECT_GROUP.SUCCESS, success);
    CustomEventListener(LIST_PROJECT_GROUP.FAIL, fail);
    return () => {
      CustomEventDispose(LIST_PROJECT_GROUP.SUCCESS, success);
      CustomEventDispose(LIST_PROJECT_GROUP.FAIL, fail);
    };
  }, []);

  React.useEffect(() => {
    if (
      !selectedIcon.url_full &&
      !selectedIcon.url_sort &&
      icons.defaults.length > 0
    ) {
      setSelectedIcon({
        url_full: icons.defaults[0].url_icon,
        url_sort: icons.defaults[0].icon,
      });
    }
  }, [icons]);

  const reorderColor = (colorList, selectedColor) => {
    const colorArr = [...colorList];
    const indexSelectedColor = colorArr.findIndex(
      (color) => color === selectedColor
    );
    if (indexSelectedColor < 5) return colorArr;
    if (indexSelectedColor !== -1) {
      colorArr.splice(indexSelectedColor, 1);
      colorArr.splice(0, 0, selectedColor);
    }

    return colorArr;
  };
  const reorderIcons = (iconsDefaults, iconsCreated, selectedIcon) => {
    const iconsDefaultsArr = [...iconsDefaults];
    const iconsCreatedArr = [...iconsCreated];
    if (selectedIcon.url_full === "") return iconsDefaultsArr;

    const indexSelectedIconDefault = iconsDefaultsArr.findIndex(
      (icon) => icon.url_icon === selectedIcon.url_full
    );
    const indexSelectedIconCreated = iconsCreatedArr.findIndex(
      (icon) => icon.url_full === selectedIcon.url_full
    );
    if (indexSelectedIconDefault !== -1 && indexSelectedIconDefault < 5)
      return iconsDefaultsArr;
    if (indexSelectedIconDefault !== -1) {
      const removedIcon = iconsDefaultsArr.splice(indexSelectedIconDefault, 1);
      iconsDefaultsArr.splice(0, 0, removedIcon[0]);
    }

    if (indexSelectedIconCreated !== -1) {
      const foundedIconCreated = iconsCreatedArr[indexSelectedIconCreated];
      const iconCreatedMapped = {
        icon: foundedIconCreated.url_sort,
        url_icon: foundedIconCreated.url_full,
      };

      iconsDefaultsArr.splice(0, 0, iconCreatedMapped);
    }

    return iconsDefaultsArr;
  };

  const orderedColorArr = reorderColor(colors, selectedColor).splice(0, 5);
  const orderedIconArr = reorderIcons(
    icons.defaults,
    icons.createds,
    selectedIcon
  ).splice(0, 5);

  const handleChange = (panel) => (event, isExpanded) => {
    setIsAddingDescription(isExpanded ? panel : false);
  };
  return (
    // <ModalCommon
    //   open={open}
    //   setOpen={setOpen}
    //   title={
    //     updatedProjectGroup
    //       ? t("DMH.VIEW.PGP.MODAL.CUPG.U_TITLE")
    //       : t("DMH.VIEW.PGP.MODAL.CUPG.C_TITLE")
    //   }
    //   btnActionsRight={[
    //     <ButtonModalCommon onClick={() => setOpen(false)}>
    //       {t("DMH.COMP.ALERT_MODAL.CANCLE_BTN")}
    //     </ButtonModalCommon>,
    //     <ButtonModalCommon
    //       variant="contained"
    //       disabled={errorName}
    //       onClick={() => {
    //         handleCreateOrEditProjectGroup(
    //           name,
    //           description,
    //           selectedIcon,
    //           selectedColor,
    //           groupID || null,
    //           onComplete
    //         );
    //       }}
    //     >
    //       {t("Complete")}
    //     </ButtonModalCommon>,
    //   ]}
    // >

    // </ModalCommon>
    <CustomModal
      title={
        updatedProjectGroup
          ? t("DMH.VIEW.PGP.MODAL.CUPG.U_TITLE")
          : t("DMH.VIEW.PGP.MODAL.CUPG.C_TITLE")
      }
      open={open}
      setOpen={setOpen}
      canConfirm={!errorName}
      onConfirm={() => {
        handleCreateOrEditProjectGroup(
          name,
          description,
          selectedIcon,
          selectedColor,
          groupID || null,
          onComplete
        );
        setActiveLoading(true);
      }}
      onCancle={() => setOpen(false)}
      activeLoading={activeLoading}
      manualClose={true}
      height={!isAddingDescription ? "mini" : "short"}
      maxWidth={"sm"}
      className=""
      dialogContentSx={{
        padding: "0px 20px",
      }}
      sxOneColumn={{
        "& .comp_CustomModal___scroll > div:nth-child(1)": {
          minHeight: "120px",
        },
      }}
    >
      <p style={{ margin: 0, fontWeight: "bold" }}>
        {t("DMH.VIEW.PGP.MODAL.CUPG.NAME")}{" "}
        <abbr
          title={t("IDS_WP_REQUIRED_LABEL")}
          style={{ color: "red", textDecoration: "none" }}
        >
          *
        </abbr>
      </p>
      <div style={{ display: "flex" }}>
        <ColorGroupPickerPopover
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          projectGroupColor={selectedColor}
          handleSelectColor={handleSelectColor}
        >
          <Box
            id="colorGroupPickerPopover__modal_groupiconadd"
            sx={{
              width: "55px",
              height: "55px",
              marginTop: "10px",
              marginRight: "10px",
              background: selectedColor,
              padding: "2px 5px",
              borderRadius: "12px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <WorkspacesIcon
              sx={{ color: "white", width: "1.2em", height: "1.2em" }}
            />
          </Box>
        </ColorGroupPickerPopover>
        <div style={{ width: "100%" }}>
          <CustomTextbox
            value={name}
            onChange={(value) => setName(value)}
            // label={t("DMH.VIEW.PGP.MODAL.CUPG.NAME")}
            fullWidth
            // required={true}
          />
          <Accordion
            expanded={isAddingDescription === "panel1"}
            onChange={handleChange("panel1")}
            className={"createProjectGroup__collapsed--container"}
          >
            <AccordionSummary
              aria-controls="panel1bh-content"
              className="createProjectGroup__collapsed--title"
            >
              {isAddingDescription ? <RemoveIcon /> : <AddIcon />}
              {t("DMH.VIEW.PGP.MODAL.CUPG.ADD_DESC")}
            </AccordionSummary>
            <AccordionDetails>
              <CustomTextbox
                value={description}
                label={t("DMH.VIEW.PGP.MODAL.CUPG.DESC")}
                onChange={(value) => setDescription(value)}
                fullWidth
                multiline={true}
                className={"createProjectGroup__collapsed--text-box"}
              />
            </AccordionDetails>
          </Accordion>
        </div>
      </div>
    </CustomModal>
  );
}

export default CreateProjectGroup;
